module.exports = '1.1.4';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 247
// module chunks = 0